import { Configuration } from '@azure/msal-browser';

export const readersGroupId = process.env.REACT_APP_READERS_GROUP_ID;
export const writersGroupId = process.env.REACT_APP_WRITERS_GROUP_ID;
export const adminsGroupId = process.env.REACT_APP_ADMINS_GROUP_ID;

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_AUTHORITY,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  }
};

export const loginRequest = {
  scopes: ["User.Read", "GroupMember.Read.All"]
};